var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8002 0.70875C13.4102 0.31875 12.7802 0.31875 12.3902 0.70875L7.50022 5.58875L2.61022 0.69875C2.22022 0.30875 1.59021 0.30875 1.20021 0.69875C0.810215 1.08875 0.810215 1.71875 1.20021 2.10875L6.09022 6.99875L1.20021 11.8887C0.810215 12.2787 0.810215 12.9087 1.20021 13.2987C1.59021 13.6887 2.22022 13.6887 2.61022 13.2987L7.50022 8.40875L12.3902 13.2987C12.7802 13.6887 13.4102 13.6887 13.8002 13.2987C14.1902 12.9087 14.1902 12.2787 13.8002 11.8887L8.91021 6.99875L13.8002 2.10875C14.1802 1.72875 14.1802 1.08875 13.8002 0.70875Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3f99b65f17f58600e51af40e15b8c044.svg";
export { ForwardRef as ReactComponent };